const SESSION_KEY = 'visualGame.behaviorSessionId'

export function createFirstPartyBehaviorTracker({ tokenStore, fetchImpl = globalThis.fetch }) {
  const sessionId = behaviorSessionId(globalThis.sessionStorage)
  let pageStartedAt = null
  let activePage = globalThis.location.pathname
  let activeTitle = globalThis.document.title || null

  function track(eventName, metadata = {}) {
    if (eventName === 'page_view') {
      flushEngagement()
      activePage = globalThis.location.pathname
      activeTitle = globalThis.document.title || null
      pageStartedAt = Date.now()
    }
    void deliver(eventName, metadata, 0)
  }

  function flushEngagement() {
    if (pageStartedAt === null) return
    const engagementMs = Math.min(Date.now() - pageStartedAt, 30 * 60 * 1000)
    pageStartedAt = null
    if (engagementMs > 0) void deliver('page_engagement', {}, engagementMs)
  }

  function resume() {
    if (pageStartedAt === null) pageStartedAt = Date.now()
  }

  async function deliver(eventName, metadata, engagementMs) {
    const accessToken = tokenStore.getAccessToken()
    const headers = {
      'content-type': 'application/json',
      'x-device-id': tokenStore.getDeviceId(),
    }
    if (accessToken) headers.authorization = `Bearer ${accessToken}`
    try {
      await fetchImpl('/api/visual-game/behavior-events', {
        method: 'POST',
        headers,
        keepalive: true,
        body: JSON.stringify({
          id: globalThis.crypto.randomUUID(),
          session_id: sessionId,
          event_name: eventName,
          page_path: activePage,
          page_title: activeTitle,
          metadata: safeMetadata(metadata),
          engagement_ms: engagementMs,
          occurred_at: new Date().toISOString(),
        }),
      })
    } catch (error) {
      console.warn('[visual-game] first-party behavior delivery failed', error)
    }
  }

  return Object.freeze({ flushEngagement, resume, track })
}

function behaviorSessionId(storage) {
  const stored = storage.getItem(SESSION_KEY)
  if (stored) return stored
  const id = globalThis.crypto.randomUUID()
  storage.setItem(SESSION_KEY, id)
  return id
}

function safeMetadata(metadata) {
  return Object.fromEntries(Object.entries(metadata).filter(([, value]) => ['string', 'number', 'boolean'].includes(typeof value)))
}
